import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { brandTriplets, brandDarkTriplets } from 'dashboard/theme/brand';

// Overrides the next-design-system accent (--blue-1..12 from
// _next-colors.scss) with the product brand scale — the single source of
// truth lives in dashboard/theme/brand.js. Inline styles on <body> win over
// the stylesheet for both light and dark themes.
const applyBrandAccent = isDarkMode => {
  const scale = isDarkMode ? brandDarkTriplets : brandTriplets;
  Object.entries(scale).forEach(([step, triplet]) => {
    document.body.style.setProperty(`--blue-${step}`, triplet);
  });
};

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  const isDarkMode =
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark';

  if (isDarkMode) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
  applyBrandAccent(isDarkMode);
};
